<!--  -->
import { try } from 'q';
<template>
  <Card ref="detailCard">
    <div slot="title" class="album-title box">详情</div>
    <div slot="extra" class="button_upload" @click="router(id)">编辑</div>
    <!-- <div class="box detail-wrapper" :style="{height:bodyHeight}"> -->
    <div class="box detail-wrapper">
      <div class="picBox" v-bind:style="{backgroundImage:'url('+activityInfo.cover+')'}"></div>
      <div class="infoBox">
        <div class="acttitle">
          {{ activityInfo.title }}
          <span class="state">{{activityInfo.cnstate}}</span>
        </div>
        <div class="infos">主办方：{{activityInfo.sponsorName }}</div>

        <div class="activity-type-list">
          <div class="activity-type-outline">
            <div class="activity-type">{{ activityInfo.activitytype }}</div>
          </div>
        </div>
        <!--<div class="infos box">-->
        <!--<div class="iconfont icon-gonggao2  icon"></div>-->
        <!--<div>提前{{ activityInfo.remind }}天提醒活动开始</div>-->
        <!--</div>-->
        <div class="infos box">
          <!-- 积分 -->
          <div class="infos-score">
            <span class="iconfont icon-jifen2 icon"></span>
            <span>积分：{{ activityInfo.score / 100 }}</span>
          </div>
          <!-- 报名人数 -->
          <div class="infos-enroll">
            <span class="iconfont icon-shichang- icon"></span>
            <span>时长：{{activityInfo.timeLength}}</span>
          </div>
        </div>

        <div class="infos box">
          <div class="iconfont icon-ai206 icon"></div>
          <div>{{ activityInfo.contact }}&nbsp;&nbsp;&nbsp;( {{activityInfo.tel }} )</div>
        </div>
        <div class="infos box">
          <div class="iconfont icon-time icon"></div>
          <div style="display:block ">
            {{$util.FormatDate(activityInfo.starttime,"yyyy-MM-dd HH:mm:ss")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$util.FormatDate(activityInfo.endtime,"yyyy-MM-dd HH:mm:ss")}}
            <!--{{ $util.FormatDate(parseInt(activityInfo.starttime))}}&nbsp;&nbsp;&nbsp;{{$util.FormatDate(parseInt(activityInfo.starttime),'HH:mm:ss')}}&nbsp;&nbsp;&nbsp;&nbsp;~&nbsp;&nbsp;&nbsp;&nbsp;{{ $util.FormatDate(parseInt(activityInfo.endtime))}}&nbsp;&nbsp;&nbsp;{{$util.FormatDate(parseInt(activityInfo.endtime),'HH:mm:ss')}}-->
          </div>
        </div>

        <div class="infos box">
          <div class="iconfont icon-didian icon"></div>
          <div>{{ activityInfo.address }}</div>
        </div>
      </div>
      <div class="codeBox">
        <!-- <p class="sao">扫一扫分享到微信</p> -->
        <div class="cobox"  @mouseover="imgHover()" @mouseout="imgOut()" :style="activityInfo.qrcode.length > 1? 'margin-left: 20px;display: inline-block':''" v-for="(item, index) in activityInfo.qrcode" :key="index">
          <Spin fix v-show="isLoading"></Spin>
          <div class="shadow pointer" v-show="isShowShadow && (!isLoading)" @click="reloadImg">
            <span class="iconfont icon-zhongzhi icon"></span>
            <span>重新加载</span>
          </div>
          <img v-if="!isImgFail" :src="item" @error="noImg()"  >
          <div v-if="isImgFail && (!isLoading)" class="imgerror box pointer" @click="reloadImg">
            <span class="iconfont icon-zhongzhi icon"></span>
            <span>重新加载</span>
          </div>
        </div>
        <div class="btn1" :data-url="activityInfo.qrcode" data-type="活动"  data-detail="info" @click="downCode">下载活动二维码</div>
        <div class="btn2" :data-url="activityInfo.signcode" data-type="签到" data-detail="sign"  @click="downCode">下载签到二维码</div>
      </div>
    </div>
  </Card>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    activityInfo: {
      type: Object,
      default: {}
    },
    id: {
      type: 0,
      default: Number
    }
  },
  components: {},
  data() {
    //这里存放数据
    return {
      bodyHeight: "",
      isImgFail:false,
      isShowShadow:false,
      isLoading:false
    };
  },
  //监听属性 类似于data概念
  computed: {
    /* 根据刷新报名人数刷新 */
    enrollment() {
      return this.$store.state.enrollment || this.activityInfo.enrollment;
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    /**鼠标悬浮 */
    imgHover(){
      this.isShowShadow = this.isImgFail?false:true
    },
    /**鼠标移出 */
    imgOut(){
      console.log('-------imgOut--------')
      this.isShowShadow = false
    },
    reloadImg(){
      this.isLoading = true
      this.isShowShadow=false
       this.$post(this.urlobj.reloadQrcode(this.id)).then(res => {
         this.isLoading = false
         this.isImgFail=false
         this.activityInfo.qrcode = res.newPrimaryKeys.qrcodeUrl.split(',')
         this.activityInfo.signcode = res.newPrimaryKeys.signQRcodeUrl.split(',')
         console.log(res.newPrimaryKeys.qrcodeUrl)
         console.log(this.activityInfo)
       }).catch(e=>{
         this.isLoading = false
          this.$Message.error('二维码加载失败，请重试')
       })
       
    },
    noImg(){
      this.isImgFail=true
    },
    downCode: function(e) {
      // console.log(e.target.dataset)
      // return
      var type = e.target.dataset.detail
      var id = this.id
      let url2 = this.urlobj.canDownActCode(id,type)
      url2 +="?isPoster=1"
      this.$get(url2, {})
      .then(res => {
        if(res.isSucceed){
         
          var url = this.urlobj.downActCode(id,type)
          url +="?isPoster=1"
        
          window.open(url)
        }else{
           // this.$Message.warning("图片生成中，请稍后再试");
        }
        
      }).catch(e=>{
          //this.$Message.warning("图片生成中，请稍后再试");
      })
      
    
      // return
      // var urlList = e.target.dataset.url.split(',')
      // urlList.forEach(item => {
      //   window.open(
      //   this.urlobj.downloadAttachment +
      //     `?picPath=${item}&picName=${
      //       this.activityInfo.title
      //     }-${e.target.dataset.type}二维码&token=${sessionStorage.getItem(
      //       "token"
      //     )}`
      // );
      // })
    },
    router(id) {
      this.$router.push({
          name: "newactivity",
          query: { id, isFromDetail: 1 }
        });
      
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //减padding和头
    this.bodyHeight =
      parseInt(this.$refs.detailCard.$el.offsetHeight - 40 - 57) + "px";
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.detail-wrapper {
  height: 100%;
  width: 420px;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
/* 封面图 */
.picBox {
  width: 400px;
  height: 250px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #ccc;
  background-size: 480px 300px;
}
/* 二维码 */
.codeBox {
  width: 310px;
  .sao {
    text-align: center;
    margin-bottom: 10px;
    color: #333;
    font-size: 16px;
  }
  .cobox {
    width: 135px;
    height: 135px;
    margin: 0 auto;
    margin-bottom: 10px;
    position: relative;
    // display: inline-block;
    // margin-left: 20px;
  }
  .cobox img {
    width: 100%;
    height: 100%;
  }
  .cobox .imgerror{
    width: 100%;
    height: 100%;
    border:1px solid #dddddd;
    border-radius: 2px;
    font-size: 14px;
    color: #67799d;
    align-items: center;
    justify-content: center;
  }
  .btn {
    width: 150px;
    height: 36px;
    border: 1px solid #ff7b43;
    text-align: center;
    line-height: 36px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 auto;
    font-size: 14px;
  }
  .btn1 {
    .btn;
    color: #ff7b43;
    margin-bottom: 10px;
  }
  .btn2 {
    .btn;
    color: #fff;
    background-color: #ff7b43;
  }
}
/* 信息面板 */
.infoBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  .acttitle {
    color: #333;
    font-size: 20px;
    align-items: center;
    max-width: 80%;
    text-align: center;
    word-wrap: break-word;
    word-break: break-all;
  }
  .state {
    display: inline-block;
    line-height: 18px;
    text-align: center;
    margin-left: 8px;
    font-size: 8px;
    color: #ff7b43;
    border-radius: 20px;
  }
}
/* 活动分类 */
.activity-type-list {
  max-width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 8px;
  margin-bottom: 12px;
}
.activity-type-outline {
  // border: 1px solid #ff7b43;
  // border-radius: 20px;
}
.activity-type {
  color: #ff7b43;
  font-size: 14px;
  // border: 1px dashed #ff7b43;
  height: 30px;
  line-height: 30px;
  border-radius: 6px;
  background-color: #ffebe3;
  padding: 0 8px;
  margin: 2px;
}

.infos {
  align-items: center;
  position: relative;
  color: #a1a1a1;
  font-size: 14px;
  margin-bottom: 4px;
  .icon {
    margin-right: 14px;
    line-height: 1em;
  }
  .infos-score,
  .infos-enroll {
    display: flex;
    align-items: center;
  }
}
.infos-score {
  margin-right: 20px;
}

.album-title {
  height: 28px;
  line-height: 28px;
}
.button_upload {
  position: relative;
  background-color: #ff7b43;
  border: 1px solid #ff7b43;
  border-radius: 4px;
  color: #fff;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  padding: 0 16px;
  cursor: pointer;
}

.shadow{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
</style>
